import hljs from 'highlight.js';

import * as React from 'react';
import ReactUtterances from 'react-utterances';

import { BlogContextProvider } from './BlogPostContext';
import HeadPost from './HeadPost';
import Layout from './Layout';

const prd = process.env.NODE_ENV === 'production';

export type Props = React.PropsWithChildren<{
  meta: MetaData;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, react/require-default-props
  staticProps?: any;
}>;

export default function BlogPost({ children, meta, staticProps }: Props) {
  React.useEffect(() => {
    // console.log('initHighlighting');
    hljs.highlightAll();
  }, []);
  // console.log('BlogPost', { staticProps });
  return (
    <>
      <Layout title={meta.title}>
        <HeadPost meta={meta} isBlogPost />
        <BlogContextProvider staticProps={staticProps}>
          <article className="markdown">{children}</article>
        </BlogContextProvider>
        {prd && <ReactUtterances repo="swcho/blog-comments" type="pathname" label="utterances" theme="github-light" />}
      </Layout>
    </>
  );
}
